"use strict";

// The env files hold the only copy of these budgets. A value that is missing, malformed
// or not positive disables its timer, because falling back to no timeout keeps the old
// behavior while a zero delay would abort every fetch on the spot.
const readTimeout = (value) => {
  const ms = Number(value);
  return Number.isFinite(ms) && ms > 0 ? ms : null;
};

const RESPONSE_TIMEOUT_MS = readTimeout(import.meta.env.VITE_CONFIG_FETCH_RESPONSE_TIMEOUT_MS);
const BODY_TIMEOUT_MS = readTimeout(import.meta.env.VITE_CONFIG_FETCH_BODY_TIMEOUT_MS);

const abortAfter = (controller, delayMs) => (delayMs ? setTimeout(() => controller.abort(), delayMs) : null);

// The response start and the body download get separate fixed budgets: a host that does
// not answer is cut off after RESPONSE_TIMEOUT_MS, and once the response starts the body
// gets BODY_TIMEOUT_MS more before the fetch aborts, done or not. The split gives slow
// networks (e.g. competing with the parallel SDK download) more total room than a single
// short deadline would.
export default async function fetchJsonWithTimeouts(url) {
  const controller = new AbortController();
  let timeoutId = abortAfter(controller, RESPONSE_TIMEOUT_MS);
  try {
    const response = await fetch(url, { method: "GET", signal: controller.signal });
    if (!response.ok) {
      controller.abort();
      throw new Error(`Request to ${url} failed with status ${response.status}`);
    }
    clearTimeout(timeoutId);
    timeoutId = abortAfter(controller, BODY_TIMEOUT_MS);
    return await response.json();
  } finally {
    clearTimeout(timeoutId);
  }
}
